import moment from 'moment'

export default class MonthCard {
  constructor(selector) {
    this.$el = $(selector)
    let grid = this.$el.find(".month-grid")

    this.selectedMonth = moment(grid.data("selected"))
    this.originalYear = this.selectedMonth.year()
    this.originalCard = this.$el.html()

    this.nextYearCallback = this.nextYear.bind(this)
    this.prevYearCallback = this.prevYear.bind(this)
    this.selectMonthCallback = this.selectMonth.bind(this)

    this.checkSelected()
    this.listen()
  }

  checkSelected() {
    let selected = this.selectedMonth.format("YYYY-MM-DD")
    this.$el.find("td").each((i, cell) => {
      if (cell.dataset.month === selected) {
        cell.classList.add("selected")
      }
    })
  }

  changeYear(event, delta) {
    event.stopImmediatePropagation()
    let yearEl    = this.$el.find(".current-year")
    let year      = +yearEl.text() + delta
    let regex     = new RegExp(this.originalYear, "g")
    let cardHTML  = this.originalCard.replace(regex, year)
    this.$el.html(cardHTML)
    yearEl.text(year)
    this.checkSelected()
  }

  nextYear(event) {
    return this.changeYear(event, 1)
  }

  prevYear(event) {
    return this.changeYear(event, -1)
  }

  selectMonth(event) {
    event.stopImmediatePropagation();
    N2.mergeParams({issue: event.target.dataset.month})
  }

  listen() {
    N2.bindGlobalHandler("click", ".month-card .next-year", this.nextYearCallback)
    N2.bindGlobalHandler("click", ".month-card .prev-year", this.prevYearCallback)
    N2.bindGlobalHandler("click", ".month-card td", this.selectMonthCallback)
  }
}
